require './account'

App.LogisticsStaff = LogisticsStaff = App.Account.extend
  logistics_center: DS.belongsTo 'logistics_center', async: true
  role              : DS.attr 'string'
  restaurants:      DS.hasMany   'restaurant',   async: true

  isAdmin:          Em.computed.equal 'role', 'admin'
  isManager:        Em.computed.equal 'role', 'manager'
  isManagerLogist:  Em.computed.equal 'role', 'manager_logist'
  isLogist:         Em.computed.equal 'role', 'logist'

  isLogisticsStaff: true

  notifications: DS.attr 'mixed',  defaultValue: App.Account.DEFAULT_NOTIFICATIONS

  order_created_url:        DS.attr 'string'
  order_status_changed_url: DS.attr 'string'


LogisticsStaff.DEFAULT_NOTIFICATIONS = App.Account.DEFAULT_NOTIFICATIONS
LogisticsStaff.DISABLED_NOTIFICATIONS = App.Account.DISABLED_NOTIFICATIONS


module.exports = LogisticsStaff
